<template>
	<button
		:data-target="target" 
		:class="`btn btn-light ${classes}`"
		:id="id"
		@click="executarAcao"
	>
		{{ texto }}
		<span class="ml-1 float-right">
			<span class="material-symbols-outlined">{{ icone }}</span>
		</span>
	</button>
</template>

<script setup>
import {ref, defineProps, defineEmits} from 'vue';

const icones = {
	verMais: "keyboard_arrow_down",
	verMenos: "keyboard_arrow_up",
}

const textos = {
	verMais: 'Ver mais',
	verMenos: "Ver menos",
}

const props = defineProps({
	classes: String,
	target: String,
	textoAbrir: String,
	textoFechar: String,
	id: String
});

let texto = ref(props.textoAbrir || textos.verMais);
let icone = ref(icones.verMais);

const emit = defineEmits(['acaoVerMais']);

function executarAcao() {	
	icone.value = icone.value === icones.verMais ? icones.verMenos : icones.verMais;
	texto.value = texto.value === props.textoAbrir ? props.textoFechar : props.textoAbrir;
	emit('acaoVerMais', props.target);
}

</script>
